export enum CommunicationMode {
  TRIGGERED_BY_US = 'TRIGGERED_BY_US',
  TRIGGERED_BY_SCALE = 'TRIGGERED_BY_SCALE',
}
